import { put } from "@redux-saga/core/effects";
import { IntegrationService } from "../integration.service";
import { getMailchimpSelectedFieldsFailure, getMailchimpSelectedFieldsSuccess } from "../actionCreators";
import { GetMailchimpSelectedFieldsRequestActionType } from "../types";

export function* getMailchimpSelectedFieldsSaga({
    payload: { formId, listId },
}: GetMailchimpSelectedFieldsRequestActionType) {
    try {
        const { data } = yield IntegrationService.getMailchimpSelectedFields(formId, listId);

        yield put(getMailchimpSelectedFieldsSuccess({ success: true, message: "", selectedFields: data.data }));
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to fetch Mailchimp Fields";
        yield put(getMailchimpSelectedFieldsFailure(errorMessage));
    }
}
